module.exports = __webpack_public_path__ + "img/mariadb.689cb120.png";